"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dappRead = void 0;
var node_fetch_1 = __importDefault(require("node-fetch"));
var advise_1 = require("./advise");
var adviseUser_1 = require("./adviseUser");
var dappRead = function (_a) {
    var nodeApi = _a.nodeApi, evaluator = _a.evaluator, evaluator2 = _a.evaluator2, main = _a.main, _b = _a._fetch, _fetch = _b === void 0 ? node_fetch_1.default : _b;
    return ({
        advise: function () { return (0, advise_1.advise)({ nodeApi: nodeApi, evaluator: evaluator, evaluator2: evaluator2, main: main, _fetch: _fetch }); },
        adviseUser: function (userAddress) { return (0, adviseUser_1.adviseUser)({ nodeApi: nodeApi, evaluator: evaluator, evaluator2: evaluator2, main: main, userAddress: userAddress, _fetch: _fetch }); },
    });
};
exports.dappRead = dappRead;
//# sourceMappingURL=dappReadV2.js.map